import ContactView from './ContactView'

export default ContactView